import { useCallback } from 'react';

import { useAppStore } from '../store/appStore';

/* Mise à jour de l'état persistant `st` : la fonction reçoit une copie (clients, phases, briques,
   devs et affectations recopiés) et renvoie le nouvel état. Les préférences d'affichage (vue,
   début et largeur de la frise) sont gardées dans le navigateur. */
export function useStateUpdater() {
  const setAppState = useAppStore((etat) => etat.setAppState);
  const save = useCallback((newSt) => {
    try {
      localStorage.setItem(
        'pdc3_ui',
        JSON.stringify({ view: newSt.view, tlStart: newSt.tlStart, tlDays: newSt.tlDays }),
      );
    } catch (e) {}
  }, []);

  return function update(fn) {
    setAppState((prev) => {
      const next = fn({
        ...prev,
        clients: (prev.clients || []).map((c) => ({
          ...c,
          phases: (c.phases || []).map((ph) => ({ ...ph, briques: [...(ph.briques || [])] })),
        })),
        devs: [...prev.devs.map((d) => ({ ...d, absences: [...(d.absences || [])] }))],
        affectations: [...prev.affectations],
      });
      save(next);
      return next;
    });
  };
}
